import React from "react";
import TimeIcon from "../../../../../assets/icons/TimeIcon";
import { PrimaryButton } from "../../../../../components/primary/PrimaryButton";

const ApprovalStep = ({ disabled, onNext }) => {
  return (
    <>
      <div className="flex items-center justify-center mt-10 mb-3">
        <div className="">
          <TimeIcon size="100" />
        </div>
      </div>

      <div className="justify-center w-full text-center">
        <p className="text-primary mb-2" style={{ color: "#1E5F6B" }}>
          Aprobación de
          <br /> documentos pendiente
        </p>
        <PrimaryButton disabled={disabled} onClick={onNext}>
          Siguiente
        </PrimaryButton>
      </div>
    </>
  );
};

export default ApprovalStep;
